import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Stack, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import GlobalWrapper from "../../../components/Wrapper/GlobalWrapper";
import JobSelector from "./JobSelector";
import ApplicantsTable from "./ApplicantsTable";
import { getJobs, getJobApplications } from "../../../redux/features/careerSlice";

// Sidebar "Applicants" page: latest job selected by default; change via the dropdown.
const CareerApplicantsPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { jobData, applicants, loading } = useSelector((state) => state.career);
  const [job, setJob] = useState(null);
  const autoSelected = useRef(false);
  // whether the jobs call has come BACK, which is not the same as whether there
  // are any. Without this, a module with no jobs says "Loading jobs…" for ever.
  const [jobsLoaded, setJobsLoaded] = useState(false);

  // load jobs (already ordered latest-first by the API) for the dropdown
  useEffect(() => {
    dispatch(getJobs({ page: 1, limit: 100, filter: "" })).finally(() =>
      setJobsLoaded(true),
    );
  }, [dispatch]);

  // once jobs arrive, default-select the latest (first) so the list shows immediately
  useEffect(() => {
    const jobs = jobData?.data || [];
    if (!autoSelected.current && jobs.length) {
      autoSelected.current = true;
      setJob(jobs[0]);
      dispatch(getJobApplications(jobs[0].career_job_id));
    }
  }, [jobData, dispatch]);

  // selecting a job (re)loads its applicants + unread counts; no background poll
  const onSelect = (j) => {
    setJob(j);
    if (j) dispatch(getJobApplications(j.career_job_id));
  };

  const jobs = jobData?.data || [];

  return (
    <GlobalWrapper title={"Applicants"}>
      <JobSelector jobs={jobs} value={job} onChange={onSelect} />
      {job ? (
        <ApplicantsTable
          rows={applicants?.data || []}
          counts={applicants?.meta?.counts || {}}
          loading={loading}
        />
      ) : !jobsLoaded ? (
        <Typography color="text.secondary">Loading jobs…</Typography>
      ) : (
        // no job selected. Which of the two reasons it is matters: an empty
        // module needs a job posting, a full one just needs a pick.
        <Stack spacing={1.5} alignItems="flex-start" sx={{ mt: 2 }}>
          <Typography color="text.secondary">
            {jobs.length
              ? "Pick a job above to see who applied."
              : "No jobs have been posted yet."}
          </Typography>
          {!jobs.length && (
            <Button variant="outlined" size="small" onClick={() => navigate("/career-connect/jobs")}>
              Go to Jobs
            </Button>
          )}
        </Stack>
      )}
    </GlobalWrapper>
  );
};

export default CareerApplicantsPage;
